// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"618":"4e625e61","1496":"928cbd28","1503":"a88472b9","1526":"928cbd28","2885":"1ed7f894","9421":"5e026f5d"}[chunkId] + ".chunk.css";
};